<template>
  <div id="app-download">
      <app-download-modal v-if="modal.screenIsOpen" @toggle="toggleModal">
        <div class="app-download-body">
          <div class="leads-app-icon">
            <img src="../../../assets/leads-app.png" alt="Leads App">
          </div>
          <h3>{{$t('ui.modals.download_app.title')}}</h3>
          <p>{{$t('ui.modals.download_app.subtitle')}}</p>
          <a href="https://apps.apple.com/us/app/hileadzz/id1344775133" target="_blank">
            <img class="app-store-btn" src="../../../assets/apple-btn.png" alt="Appel Store">
          </a>
          <hr>
          <a href="https://play.google.com/store/apps/details?id=de.fanomena.hileadzz.cordovaapp&hl=en" target="_blank">
            <img class="app-store-btn" src="../../../assets/google-btn.png" alt="Google Store">
          </a>
          <div class="options">
            <p id="finish" @click="finish">{{$t('ui.modals.download_app.skip')}}</p>
          </div>
          <div class="back-actions">
          </div>
        </div>
      </app-download-modal>
    </transition>
  </div>
</template>

<script>
import eq from 'lodash/eq'

import AppDownloadModal from '@/components/layouts/partials/AppDownloadModal'
import UserApi from '@/api/User'

const MAX_AGE_COOKIE = 60 * 60 * 24 * 7 * 4 * 12 * 10 // 10 years
const COOKIE_KEY_VALUE = 'is-seen-app-download-modal=true'

export default {
  components: {
    AppDownloadModal
  },
  data(){
    return {
      modal: {
        screenIsOpen: false,
        hasMask: false,
      },
    }
  },

  mounted() {
    // Show modal only if not seen before
    if (eq(document.cookie.indexOf(COOKIE_KEY_VALUE), -1)) {
      this.modal.screenIsOpen = true
    }
  },

  methods: {
    toggleModal() {
      this.modal.screenIsOpen = !this.modal.screenIsOpen
    },

    finish() {
      this.modal.screenIsOpen = false
      document.cookie = `${COOKIE_KEY_VALUE};max-age=${MAX_AGE_COOKIE}`
    }
  }
}
</script>
<style lang="scss">
#app-download {
  @media(min-width: 575px) {
    display: none;
  }

  [v-cloak] {
    display: none;
  }
h3 {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 0.5em;
}
p {
  font-size: 14px;
  color: $ink-light;
  margin-bottom: 30px;
}
hr {
  border: 0;
  border-top: 1px solid $paper;
  width: 100px;
  margin: 20px auto;
}

.options {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  p {
    color: $sensual;
    font-weight: 500;
    cursor: pointer;
  }
}
.app-store-btn {
  max-width: 146px;
}

.leads-app-icon {
  margin-bottom: -5em;
  img {
    max-width: 230px;
    margin: 0 auto;
  }
}
.app-download-modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  &__mask {
    background: rgba(#000,.65);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &__wrapper {
    position: relative;
    background: #fff;
    color: #333;
    display: flex;
  }
  &__x {
    cursor: pointer;
    font-size: 2em;
    line-height: .5;
    opacity: 1;
    position: absolute;
    top: .6em;
    right: .45em;
    &:hover {
      opacity: .65;
    }
  }
  &-enter-active,
  &-leave-active {
    transition: opacity .25s
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}



// modal content sliders
.app-download-body {
  flex: 1 1 100%;
  height: 100vh;
  flex-direction: column;
  overflow: auto;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 1em;

}
.onboarding-footer {
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: var(--axis-reverse, row-reverse);
  justify-content: space-between;
  align-items: center;
  background: #fff;
  &:not(:empty) {
    padding: 0em 1.7em;
  }

  .skip {
    color: #D2DCDD;
    cursor: pointer;
    font-size: 17px;
    @media(max-width: 600px) {
      font-size: 14px;
    }
  }
  .next,.save {
    color: #007AFF;
    cursor: pointer;
    font-size: 17px;
  }
}


.forward-actions,
.back-actions {
  flex: 1;
  display: flex;
  flex-direction: var(--axis, row);
}
.forward-actions {
  justify-content: flex-end;
  // text-align: right;
}
.back-actions {
  justify-content: flex-start;
  // text-align: left;
}

}
</style>



// WEBPACK FOOTER //
// AppDownloadScreen.vue?038ba9cb